"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SquaredDifference = 'SquaredDifference';
exports.Square = 'Square';
exports.NonMaxSuppressionV5 = 'NonMaxSuppressionV5';
/**
 * TensorFlow.js-only kernels
 */
exports.FromPixels = 'FromPixels';
//# sourceMappingURL=kernel_names.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@tensorflow/tfjs-core/dist/kernel_names.js
 ** module id = 88
 ** module chunks = 0
 **/